import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { UnitComponent } from '../unit/unit.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-unit-list',
  templateUrl: './unit-list.component.html',
  styleUrls: ['./unit-list.component.css']
})
export class UnitListComponent implements OnInit {

  public menu_item_id = '29';
  public add_auth;
  public edit_auth;
  public del_auth;
  private dp = [];
  displayedColumns = ['unit_name', 'unit_name_en', 'edit', 'del'];  // , 'unitType'
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<UnitComponent>;
  @ViewChild(MatSort) sort: MatSort;

  model = { 'table_name': 'unit', 'unit_name': '', 'unit_name_en': '' };  // , 'unit_type': ''

  Success_Msg; Error_Msg; Del_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

  }


  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);
  }

  search() {

    let condition = "";

    if (this.model['unit_name'] != '')
      condition = " (`unit_name` LIKE '%" + this.model['unit_name'] +
        "%' OR `unit_name_en` LIKE '%" + this.model['unit_name'] + "%') AND ";

    let query = "SELECT * FROM `unit` WHERE" + condition + " `status` = '1'";
    let obj = { cmd: 'getList', query: query };


    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        // data.data['list'].forEach(element => {
        //   if (element.unit_type == 'primary')
        //     element.unitType = 'وحدة أساسية';
        //   else
        //     element.unitType = 'وحدة مرتبطة بوحدة أخرى';
        // });
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });


  }

  newUnit() {
    this.addDialogRef = this.dialog.open(UnitComponent, {
      hasBackdrop: false,
      //data: this.dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        // if (result != null && result['status'] == 'success')
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  editUnit(row) {
    let dialog_data = {
      'table_name': 'unit', 'unit_id': row.unit_id,
      'unit_name': row.unit_name,
      'unit_name_en': row.unit_name_en,
      'comment': row.comment
    };

    this.addDialogRef = this.dialog.open(UnitComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });

    // 'unit_type': row.unit_type,
    // 'from_unit': row.from_unit,
    // 'quantity': row.quantity,
  }

  delUnit(row) {
    if (confirm("نتيجة الحذف قد تؤثر على بيانات أخرى، هل أنت متأكد من رغبتك بالاستمرار؟")) {
      let values = [{ 'table_name': this.model['table_name'], 'unit_id': row.unit_id }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(" تمت العملية بنجاح ");
            this.search();
          }
          else {
            alert(" حدث خطأ الرجاء المحاولة مرة أخرى ");
          }
        });
    }
  }

}
